import React, { useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import Card from "./Card";
import "./Page1.css";
import "./YoutubeEmbed.css";

function Page1() {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);

  async function fetchBlogsData() {
    setLoading(true);
    try {
      const data = JSON.parse(localStorage.getItem("main-page"));
      setPosts(data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchBlogsData();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Hero Quote Header */}
      <div className="mb-10 text-center max-w-3xl mx-auto">
        <p className="text-base sm:text-lg font-medium text-slate-600 leading-relaxed">
          <span className="block text-2xl sm:text-3xl md:text-4xl font-black tracking-tight googlefont text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-indigo-600 to-rose-600 pb-2">
            "There is no better feeling in the world than holding your precious
            child."
          </span>
        </p>
      </div>

      {/* Grid Container */}
      {loading ? (
        <div className="flex justify-center items-center py-20 min-h-[300px]">
          <Spinner type="Loading posts..." />
        </div>
      ) : posts && posts.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-4 md:gap-6 place-items-center">
          {posts.map((post) => (
            <Card key={post.id || post._id || post.title} post={post} />
          ))}
        </div>
      ) : (
        /* Empty State */
        <div className="text-center py-16 px-4 bg-slate-50 rounded-2xl border border-dashed border-slate-200">
          <p className="text-slate-500 font-medium text-lg">
            No posts found at the moment. Check back soon!
          </p>
        </div>
      )}
    </div>
  );
}

export default Page1;
